import * as Yup from "yup";

export const ValidationSchema = Yup.object({
  email: Yup.string().email("Your email address is invalid").required("Email is required !"),
});
